import Moment from "moment";
import {
  GetSolicitudesApi,
  GetDraftComplains,
  GetSolicitudesPendientesTrabajador,
  listaRoles,
  listaBaterias,
  CrearSolicitud,
  listaCargosTipos,
  GetSolicitudesById,
  GetWorkersApi,
  DeleteSolicitudApi,
  listaCentros
} from "../../../../../services/solicitudesAgendaSelApi";
import { getLists } from "../../../../Global/actions";
import validaciones from "../../../../../helpers/validaciones";
import trace from "../../../../../helpers/trace";
import { showToastError, showMessageApi } from "../../../../Main/actions";


export const loading = (isLoading) => ({
  type: "LOADING_SOLICITUDES_EMPRESA_SEL",
  isLoading,
});

export const nextStep = () => ({
  type: "NEXT_STEP_SEL",
});

export const lastStep = () => ({
  type: "LAST_STEP_SEL",
});

export const setStep = (step) => ({
  type: "SET_STEP_SEL",
  step,
});

export const setSolicitudesEmpresa = (listaSolicitudes, filtros, total) => ({
  type: "SET_SOLICITUDES_EMPRESA_SEL",
  listaSolicitudes,
  filtros,
  total,
});

export const setSolicitudesEmpresaFiltrada = (listaSolicitudesFiltrada) => ({
  type: "SET_SOLICITUDES_EMPRESA_FILTRADA_SEL",
  listaSolicitudesFiltrada,
});

export const setSolicitudesEmpresaFiltradaTotal = (total) => ({
  type: "SET_SOLICITUDES_EMPRESA_FILTRADA_TOTAL_SEL",
  total,
});

export const setSolicitudesEmpresaFiltradaFiltros = (filtros) => ({
  type: "SET_SOLICITUDES_EMPRESA_FILTRADA_FILTROS_SEL",
  filtros,
});

export const setShowHideForm = (showHideForm) => ({
  type: "SET_SHOWHIDE_FORM_SEL",
  showHideForm,
});

export const setDataNewComplain = (jsonData) => ({
  type: "SET_DATA_NEW_COMPLAIN_SEL",
  jsonData,
});

export const setListaEmpleadosTabla = (formatoListaEmpleados) => ({
  type: "SET_LISTA_EMPLEADOS_TABLA_SEL",
  formatoListaEmpleados,
});

export const setDraft = (jsonData) => ({
  type: "SET_DRAFT_SEL",
  jsonData,
});

export const setCleanDataComplain = () => ({
  type: "SET_CLEAN_DATA_COMPLAIN_SEL",
});

export const openCloseModalBorrador = (isOpen) => ({
  type: "OPEN_CLOSE_MODAL_BORRADOR_SEL",
  isOpen,
});

export const editingDraft = (editing) => ({
  type: "EDITING_DRAFT_SEL",
  editing,
});

export const setDataTrabajador = (data) => ({
  type: "SET_DATA_TRABAJADOR_SEL",
  data,
});

export const updateDataGridSolicitudes = (update) => ({
  type: "UPDATE_DATA_GRID_SOLICITUDES_SEL",
  update,
});

export const setPendingComplaints = (complaints) => ({
  type: "SET_PENDING_COMPLAINTS_SEL",
  complaints,
});

export const disableNewComplaintButton = (disable) => ({
  type: "DISABLE_NEW_COMPLAINT_BUTTON_SEL",
  disable,
});

export const openCloseModalContinue = (isOpen, id) => ({
  type: "OPEN_CLOSE_MODAL_CONTINUE_SEL",
  isOpen,
  id
});
export const openCloseModalEliminarExamen = (isOpen, data, examen) => ({
  type: "OPEN_CLOSE_MODAL_ELIMINAR_EXAMEN",
  isOpen,
  data,
  examen,
});
export const openCloseModalEliminarSolicitud = (isOpen, request) => ({
  type: "OPEN_CLOSE_MODAL_ELIMINAR_SOLICITUD",
  isOpen,
  request,
});


export const openCloseModalDelete = (isOpen) => ({
  type: "OPEN_CLOSE_MODAL_DELETE_SEL",
  isOpen,
});

export const setTipoSolicitud = (tipo) => ({
  type: "SET_TIPO_SOLICITUD_SEL",
  tipo,
});

export const setListaEmpleados = (data) => ({
  type: "SET_LISTA_EMPLEADOS_SEL",
  data,
});

export const setDataAgendaForm = (data) => ({
  type: "SET_DATA_AGENDA_FORM_SEL",
  data,
});
export const setEditTrabajadoresSN = (open) => ({
  type: "SET_EDIT_WORKERS_SN_SEL",
  open,
});
export const setDataSolicitudAgenda = (data, isLoadFromInput) => ({
  type: "SET_DATA_SOLICITUD_AGENDA_SEL",
  data,
  isLoadFromInput
});

export const changeExamenesAdicionales = (status) => ({
  type: "CHANGE_STATUS_EXAMENES_ADICIONALES_SEL",
  status,
});

export const changeExamenesPsicologicos = (status) => ({
  type: "CHANGE_STATUS_EXAMENES_PSICOLOGICOS_SEL",
  status,
});

export const setCleanSolicitudAgenda = () => ({
  type: "SET_CLEAN_SOLICITUD_AGENDA_SEL",
});

export const setDefaultCityId = (idCity) => ({
  type: "SET_DEFAULT_CITY_ID_SEL",
  idCity,
});

export const setDataBorrador = (data) => ({
  type: "SET_DATA_BORRADOR_SEL",
  data,
});

export const setSelectedSolicitudShow = (data) => ({
  type: "SET_DATA_SOLICITUD_SHOW_SEL",
  data
})

export const setWorkersUpdate = (data) => ({
  type: "SET_WORKERS_UDATED_SEL",
  status: data,
});

export const setExamsUpdate = (data) => ({
  type: "SET_EXAMS_UDATED_SEL",
  status: data,
});

export const setPoolsUpdate = (data) => ({
  type: "SET_POOLS_UPDATED_SEL",
  status: data,
});

export const setHeadersUpdate = (data) => ({
  type: "SET_HEADERS_UDATED_SEL",
  status: data,
});

export const abrirCerrarModalNuevaSolicitud = (status) => ({
  type: "ABRIR_CERRAR_MODAL_NUEVA_SOLICITUD_SEL",
  status,
});

export const setIdBorrador = (Id) => ({
  type: "SET_ID_BORRADOR_SEL",
  Id,
});

export const setStateEditBorrador = (status) => ({
  type: "SET_STATE_EDIT_BORRADOR_SEL",
  status,
});

export const setSelectedCenter = (data) => ({
  type: "SET_SELECTED_CENTER_SEL",
  data
})

export const callListMyData = (rutUsuario, lista) => async (dispatch) => {
  await dispatch(getLists(lista));
};

export const doGetComplaint = (filtros, total) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;

    const request = await GetSolicitudesApi(filtros);
    if (request.status === 200) {
      const result = await request.json();
      dispatch(setSolicitudesEmpresa(result.ListaSolicitudes, filtros, total));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("doGetComplaint", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};
export const doGetWorkersData = (ruts, data) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const clonedData = JSON.parse(JSON.stringify(data));
    const request = await GetWorkersApi(ruts);
    const takenSlot = clonedData.listaEmpleados.filter((e) => e.nombreEmpleado || e.rutEmpleado);
    let freeSlot = clonedData.listaEmpleados.filter((e) => !e.nombreEmpleado && !e.rutEmpleado);
    let message;

    if (request.status === 200) {
      const result = await request.json();
      const _result = [];
      result.forEach((e) => {
        _result.push({
          idEmpleado: e.Id,
          nombreEmpleado: e.Name,
          rutEmpleado: e.DocumentNumber,
          edadEmpleado: e.Age,
          celularEmpleado: e.Phone,
          emailEmpleado: e.Mail,
          tipoDocumento: 1,
        });
      });
      freeSlot = freeSlot.length > result.length ? freeSlot.slice(0, (freeSlot.length - result.length)) : [];
      clonedData.listaEmpleados = [...takenSlot, ..._result, ...freeSlot];
      dispatch(setDataSolicitudAgenda(clonedData, true));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("doGetWorkersData", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};
export const doGetDraft = (CompanyId, rutTrabajador) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;

    const request = await GetDraftComplains(CompanyId, rutTrabajador);
    if (request.status === 200) {
      let form = {};
      const result = await request.json();

      form = JSON.parse(result.Complaint.JsonData);
      form.Id = result.Complaint.Id;

      dispatch(setDraft(form));
      dispatch(setStep(form.currentStep));
      dispatch(editingDraft(true));
      dispatch(openCloseModalContinue(true));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("doGetDraft", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doDeleteDraft = (idComplaint, filters) => async (dispatch) => {
  dispatch(loading(true));
  try {
    if (idComplaint) {
      const requestStatus = {
        RequestId: idComplaint,
        RequestStatus: 8,
        Comment: "Borrador eliminado",
      };
      let message;

      const request = await DeleteSolicitudApi(requestStatus);
      if (request.status === 200) {
        dispatch(loadDataGrid(filters));
        message = "Borrador Eliminado.";
        dispatch(setCleanSolicitudAgenda());
        dispatch(setShowHideForm(false));
        dispatch(openCloseModalBorrador(false));
      } else {
        const result = await request.json();
        dispatch(showMessageApi(message, request, result));
      }
      dispatch(showMessageApi(message, request));
    } else {
      dispatch(setCleanSolicitudAgenda());
      dispatch(setShowHideForm(false));
      dispatch(openCloseModalBorrador(false));
    }
  } catch (e) {
    trace.error("doDeleteDraft", e);
    dispatch(showToastError());
  }
  //dispatch(loading(false));
};

export const getSolicitudesPendientes = (modalPendientes, complaintType, fechaPresentacion, data) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;

    const request = await GetSolicitudesPendientesTrabajador(data);
    if (request.status === 200) {
      const result = await request.json();
      if (result.Success) {
        modalPendientes();
        dispatch(setPendingComplaints(result.Complaints));
        const any = result.Complaints.filter((item) => item.TipoSiniestro === complaintType
          && !Moment(fechaPresentacion).isSame(item.FechaSiniestro));

        if (any.length) {
          dispatch(disableNewComplaintButton(true));
        }
      } else {
        dispatch(nextStep());
      }
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("getSolicitudesPendientes", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const sendAgendamiento = (data, companyId, userId, statusId, isUpdated, autoSave, filters, center) => async (dispatch) => {
  if (!autoSave) dispatch(loading(true));
  try {
    const formattedData = {};
    if (isUpdated && isUpdated.isPoolsUpdate) formattedData.isPoolsUpdate = true;
    if (isUpdated && isUpdated.isExamsUpdate) formattedData.isExamsUpdate = true;
    if (isUpdated && isUpdated.isWorkersUpdate) formattedData.isWorkersUpdate = true;
    if (isUpdated && isUpdated.isRequestHeaderUpdate) formattedData.isRequestHeaderUpdate = true;
    formattedData.StatusId = statusId || 6;
    formattedData.Id = data.idSolicitud ? data.idSolicitud : null;
    formattedData.PetitionerRut = userId || null;
    formattedData.AuthorizedRut = data.solicitante ? data.solicitante : "";
    formattedData.CostCenter = data.centroCostos ? data.centroCostos : "";
    formattedData.WorkerPositionId = data.cargo != null ? Number(data.cargo) : null;
    formattedData.OtherWorkerPosition = data.otroCargo != null ? data.otroCargo : "";
    formattedData.RequestTypeId = data.tipoEvaluacion ? Number(data.tipoEvaluacion) : null;
    formattedData.ProposalDate = data.fechaReferencia ? Moment(data.fechaReferencia).format() : null;
    formattedData.ProposalDateEnd = data.fechaReferenciaEnd ? Moment(data.fechaReferenciaEnd).format() : null;
    formattedData.Comment = data.observaciones ? data.observaciones : "";
    formattedData.WorkersQuota = data.listaEmpleados.length > 0 ? data.listaEmpleados.length : 0;
    formattedData.CompanyRut = companyId || null;
    formattedData.PsychologicalExams = data.examenesPsicologicos.length > 0 ?
      data.examenesPsicologicos.map((e) => {
        if (!e.Id && !e.AchsOffices && e.AchsOffices.length <= 0) { return null; }
        const _return = {};
        _return.Id = e.Id ? e.Id : null;
        _return.OfficeId = e.AchsOffices ? e.AchsOffices.find((o) => o.Id === center) : null;
        _return.OfficeId = _return.OfficeId && _return.OfficeId.Id ? _return.OfficeId.Id : null;
        return _return;
      }).filter((f) => f) : null;

    formattedData.AdditionalExams = data.examenesAdicionales.length > 0 ?
      data.examenesAdicionales.map((e) => {
        if (!e.Id && !e.AchsOffices && e.AchsOffices.length <= 0) { return null; }
        const _return = {};
        _return.Id = e.Id ? e.Id : null;
        _return.OfficeId = e.AchsOffices ? e.AchsOffices.find((o) => o.Id === center) : null;
        _return.OfficeId = _return.OfficeId && _return.OfficeId.Id ? _return.OfficeId.Id : null;
        return _return;
      }).filter((f) => f) : null;

    formattedData.Pools = data.baterias.length > 0 ?
      data.baterias.map((e) => {
        if (!e.Id && !e.AchsOffices && e.AchsOffices.length <= 0) { return null; }
        const _return = {};
        _return.Id = e.Id ? e.Id : null;
        _return.OfficeId = e.AchsOffices ? e.AchsOffices.find((o) => o.Id === center) : null;
        _return.OfficeId = _return.OfficeId && _return.OfficeId.Id ? _return.OfficeId.Id : null;
        return _return;
      }).filter((f) => f) : null;

    formattedData.Workers = data.listaEmpleados.length > 0 ?
      data.listaEmpleados.map((e) => {
        const _return = {};
        _return.DocumentNumber = e.rutEmpleado && e.nombreEmpleado ? e.rutEmpleado : null;
        _return.Name = e.nombreEmpleado && e.rutEmpleado ? e.nombreEmpleado : null;
        _return.Age = e.edadEmpleado ? e.edadEmpleado : null;
        _return.Phone = e.celularEmpleado ? e.celularEmpleado : null;
        _return.Mail = e.emailEmpleado ? e.emailEmpleado : null;
        _return.DocumentType = e.tipoDocumento ? e.tipoDocumento : 1;
        return _return;
      }).filter((f) => f)
      : null;
    formattedData.Workers = formattedData.Workers && formattedData.Workers.length === 0 ? null : formattedData.Workers;
    let message;
    const _request = await CrearSolicitud(formattedData);
    if (_request.status === 201) {
      const _result = await _request.json();
      if (autoSave) {
        if (_result) { dispatch(setIdBorrador(_result)); }
        return true;
      }
      message = "Se han enviado correctamente los datos.";
      dispatch(setCleanSolicitudAgenda());
      dispatch(setCleanDataComplain());
      dispatch(setShowHideForm(false));
      dispatch(updateDataGridSolicitudes(true));
      dispatch(openCloseModalBorrador(false));
      dispatch(showMessageApi(message, _request));
      if (filters) dispatch(loadDataGrid(filters));
      return true;
    } else {
      const result = await _request.json();
      dispatch(showMessageApi(message, _request, result));
    }
  } catch (e) {
    trace.error("sendAgendamiento", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
  return false;
};

export const loadDataAgendaform = (companyId) => async (dispatch) => {
  dispatch(loading(true));
  try{
    const _roles = await listaRoles(companyId);
    const _baterias = await listaBaterias();
    const _cargosTipos = await listaCargosTipos(companyId);
    const _centros = await listaCentros();
    const _resultRoles = await _roles.json();
    const _resultBaterias = await _baterias.json();
    const _resultCargostipos = await _cargosTipos.json();
    const _resultCentros = await _centros.json()

    const solicitantes = _resultRoles && _resultRoles.Employees ? _resultRoles.Employees.map((e) => {
      e.displaySelect = `${e.Rut} ${e.EmployeeName}`;
      return e;
    }) : [];
    const centros = _resultCentros ? _resultCentros : []
    const cargos = _resultCargostipos && _resultCargostipos.Positions ? _resultCargostipos.Positions : [];
    const baterias = _resultBaterias && _resultBaterias.Pools ? _resultBaterias.Pools : [];
    const examenes = _resultBaterias && _resultBaterias.Exams ? _resultBaterias.Exams.map((e) => e.ExamTypeId === 1 ? e : null).filter((f) => f) : [];
    const psicologicos = _resultBaterias && _resultBaterias.Exams ? _resultBaterias.Exams.map((e) => e.ExamTypeId === 2 ? e : null).filter((f) => f) : [];
    const tipoExamenes = _resultCargostipos && _resultCargostipos.RequestTypes ? _resultCargostipos.RequestTypes : [];
    const tiempoSinNombre = _resultCargostipos && _resultCargostipos.Configurations ? _resultCargostipos.Configurations.find((e) => e.Type === "MAX_HOURS_SCHEDULING") : "48";
    dispatch(setDataAgendaForm({
      solicitantes, cargos, baterias, examenes, psicologicos, tipoExamenes, tiempoSinNombre, centros
    }));
  } catch (e) {
    dispatch(setDataAgendaForm({
      solicitantes: [], cargos: [], baterias: [], examenes: [], psicologicos: [], tipoExamenes: [], tiempoSinNombre: "48", centros: []
    }));
    trace.error("loadDataAgendaform", e);
    dispatch(showToastError());
  }  
  dispatch(loading(false));
};

export const loadBorradorAgenda = (IdAgenda, IdCompany, editWorker = false, editRequest) => async (dispatch) => {
  dispatch(loading(true));

  const _requestBorrador = await GetSolicitudesById(IdAgenda);
  const _baterias = await listaBaterias();
  try {
    let message;

    if (_requestBorrador.status === 200) {
      const _result = await _requestBorrador.json();
      const _resultBaterias = await _baterias.json();
      const _borrador = {};
      const _dataSolicitudAgendaSel = {};
      _dataSolicitudAgendaSel.idSolicitud = _result.Id;
      _dataSolicitudAgendaSel.solicitante = _result.AuthorizedRut;
      _dataSolicitudAgendaSel.centroCostos = _result.CostCenter;
      _dataSolicitudAgendaSel.cargo = _result.WorkerPositionId;
      _dataSolicitudAgendaSel.otroCargo = _result.OtherWorkerPosition;
      _dataSolicitudAgendaSel.tipoEvaluacion = _result.RequestTypeId;
      _dataSolicitudAgendaSel.fechaReferencia = _result.ProposalDate;
      _dataSolicitudAgendaSel.fechaReferenciaEnd = _result.ProposalDateEnd;
      _dataSolicitudAgendaSel.observaciones = _result.Comment;
      _dataSolicitudAgendaSel.listaEmpleados = _result.Workers.map((e) => ({
        tipoDocumento: e.DocumentType,
        rutEmpleado: e.DocumentNumber,
        nombreEmpleado: e.Name,
        edadEmpleado: e.Age,
        celularEmpleado: e.Phone,
        emailEmpleado: e.Mail,
        IsNoName: e.IsNoName,
        IsScheduling: e.IsScheduling,
      }));
      let _defaultCityId = null;
      let _defaultCityDescription = null;
      _dataSolicitudAgendaSel.baterias = _result.Pools.map((e) => {
        const _pool = _resultBaterias && _resultBaterias.Pools ? _resultBaterias.Pools.find((ee) => ee.Id === e.PoolId) : null;
        if (_pool) {
          _pool.AchsOffices = _pool.AchsOffices.map((o) => {
            if (o.Id === e.AchsOfficeId) {
              o.selected = true;
              _defaultCityDescription = o.Description;
              _defaultCityId = o.Id;
            } else { o.selected = false; }
            return o;
          });
        }
        return _pool;
      }).filter((f) => f);
      _dataSolicitudAgendaSel.examenesPsicologicos = _result.PsychologicalExams.map((e) => {
        const _exam = _resultBaterias && _resultBaterias.Exams ? _resultBaterias.Exams.find((ee) => ee.Id === e.ExamId) : null;
        if (_exam) {
          _exam.AchsOffices = _exam.AchsOffices.map((o) => {
            if (o.Id === e.AchsOfficeId) {
              o.selected = true;
              _defaultCityDescription = o.Description;
              _defaultCityId = o.Id;
            } else { o.selected = false; }
            return o;
          });
        }
        return _exam;
      }).filter((f) => f);
      _dataSolicitudAgendaSel.examenesAdicionales = _result.AdditionalExams.map((e) => {
        const _exam = _resultBaterias && _resultBaterias.Exams ? _resultBaterias.Exams.find((ee) => ee.Id === e.ExamId) : null;
        if (_exam) {
          _exam.AchsOffices = _exam.AchsOffices.map((o) => {
            if (o.Id === e.AchsOfficeId) {
              o.selected = true;
              _defaultCityDescription = o.Description;
              _defaultCityId = o.Id;
            } else { o.selected = false; }
            return o;
          });
        }
        return _exam;
      }).filter((f) => f);

      _borrador.defaultCityId = _defaultCityId;
      _borrador.defaultCityDescription = _defaultCityDescription;
      _borrador.dataSolicitudAgendaSel = _dataSolicitudAgendaSel;
      _borrador.examenesAdicionales = _dataSolicitudAgendaSel.examenesAdicionales.length > 0;
      _borrador.examenesPsicologicos = _dataSolicitudAgendaSel.examenesPsicologicos.length > 0;

      if (_dataSolicitudAgendaSel && _dataSolicitudAgendaSel.listaEmpleados && _dataSolicitudAgendaSel.listaEmpleados.length) {
        const listaWorkers = [..._dataSolicitudAgendaSel.listaEmpleados];
        _borrador.dataSolicitudAgendaSel.listaEmpleados = listaWorkers;
        dispatch(setListaEmpleadosTabla(listaWorkers));
      }
      dispatch(setCleanSolicitudAgenda());
      dispatch(setStep(1));
      if (!editWorker) { dispatch(setShowHideForm(true)); }
      if (editRequest) { dispatch(setHeadersUpdate(true)); }
      dispatch(loadDataAgendaform(IdCompany));
      dispatch(setDataBorrador(_borrador));
      dispatch(setStateEditBorrador(true));
      dispatch(setSelectedCenter(_defaultCityId))
      dispatch(loading(false));
    } else {
      const result = await _requestBorrador.json();
      dispatch(showMessageApi(message, _requestBorrador, result));
    }
  } catch (e) {
    trace.error("loadBorradorAgenda", e);
    dispatch(showToastError());
  }
};


export const loadDataGrid = (filtros) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;

    const request = await GetSolicitudesApi(filtros);
    if (request.status === 200) {
      const result = await request.json();
      const statusId = filtros && filtros.StatusId ? filtros.StatusId : false;

      dispatch(setSolicitudesEmpresa([...result.Data], null, null));
      dispatch(doGetSolicitudesFilters(result.Data, statusId));
      dispatch(setSolicitudesEmpresaFiltrada([...result.Data]));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("loadDataGrid ", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doGetSolicitudesFilters = (ListaSolicitudes, statusId) => async (dispatch) => {
  try {
    const filtros = [];
    if (statusId === 3) {
      filtros.push({ column: "RejectDate", name: "Fecha rechazo", type: "date" });
    } else if (statusId === 2) {
      filtros.push({ column: "ApprovalDate", name: "Fecha aprobación", type: "date" });
    } else if (statusId === 1) {
      filtros.push({ column: "CreationDate", name: "Fecha de envío", type: "date" });
    } else {
      filtros.push(
        { column: "ProposalDate", name: "Fecha propuesta - inicio", type: "date" },
        { column: "ProposalDateEnd", name: "Fecha propuesta - fin", type: "date" }
      );
    }
    let Aprobador = ListaSolicitudes.map((item) => ({ text: item.AuthorizedName, value: item.AuthorizedName })).filter((e) => e.text && e.value);
    Aprobador = validaciones.getUnique(Aprobador, "text");
    let RequestType = ListaSolicitudes.map((item) => ({ text: item.RequestTypeDescription, value: item.RequestTypeDescription })).filter((e) => e.text && e.value);
    RequestType = validaciones.getUnique(RequestType, "text");
    filtros.push(
      {
        column: "AuthorizedName", name: "Aprobador", values: Aprobador,
      },
      {
        column: "RequestTypeDescription", name: "Tipo solicitud", values: RequestType,
      }
    );
    dispatch(setSolicitudesEmpresaFiltradaFiltros(filtros));
  } catch (e) {
    trace.error("doGetSolicitudesFilters", e);
    dispatch(showToastError());
  }
};

export const loadDataSelected = (id) => async (dispatch) => {
  try {
    dispatch(loading(true));
    let message;

    const request = await GetSolicitudesById(id);
    if (request.status === 200) {
      const result = await request.json();
      if (result.WorkersPending > 0) {
        const Worker = {
          Age: null,
          DocumentNumber: "",
          DocumentType: 0,
          Id: "S/D",
          IsScheduling: false,
          Mail: null,
          Name: "Sin nombre",
          Phone: null,
          SchedulingDate: null,
        };

        for (let i = 0; i < result.WorkersPending; i++) {
          result.Workers.push(Worker);
        }
      }
      dispatch(setSelectedSolicitudShow(result))               
    } else {
      dispatch(setSelectedSolicitudShow(null));
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    dispatch(setSelectedSolicitudShow(null));
    trace.error("loadDataSelected", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};